export default __webpack_public_path__ + "static/Strategic-Planning-15fdc3b348d30ecb294ac6ac19bff091.webp";